<template>
  <v-app>
    <the-header :key="myKey" />

    <the-alerts />

    <v-main>
      <transition name="fade" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>

      
    <the-footer v-if="$route.name === 'Dashboard'" class="d-flex align-end mt-auto" />
    </v-main>


    <the-loading />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import TheHeader from "@/containers/TheHeader";
import TheAlerts from "@/components/TheAlerts";
import TheLoading from "@/components/TheLoading";
import TheFooter from "@/containers/TheFooter";

export default {
  name: "TheContainer",
  components: {
    TheHeader,
    TheAlerts,
    TheLoading,
    TheFooter,
  },
  data() {
    return {
      myKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      reloadNavbar: "identityX/reloadNavbar",
    }),
  },
  watch: {
    reloadNavbar() {
      this.forceRerender();
    },
  },
  methods: {
    forceRerender() {
      this.myKey += 1;
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
